import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { NAV_LINKS, COMPANY, API } from "../lib/site";
import axios from "axios";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Subscribed. Welcome to the briefing.");
      setEmail("");
    } catch (err) {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="global-footer" className="relative border-t border-white/10 bg-panel">
      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Newsletter */}
          <div className="md:col-span-5">
            <p className="overline mb-4">Intelligence Briefing</p>
            <h3 className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-textmain mb-6 max-w-sm">
              Stay ahead of the threat curve
            </h3>
            <form onSubmit={subscribe} className="flex max-w-md" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="newsletter-email-input"
                className="tactical-input flex-1"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="bg-steel hover:bg-steel-hover text-white px-5 flex items-center justify-center transition-colors duration-300 disabled:opacity-60"
                aria-label="Subscribe"
              >
                <ArrowRight size={20} />
              </button>
            </form>
          </div>

          {/* Links */}
          <div className="md:col-span-3 md:col-start-8">
            <p className="overline mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-textmuted hover:text-steel transition-colors duration-300 text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="overline mb-6">Contact</p>
            <address className="not-italic text-sm text-textmuted leading-relaxed space-y-3">
              <p>{COMPANY.address}</p>
              <p>
                <a href={`tel:${COMPANY.phone}`} className="hover:text-steel transition-colors duration-300">
                  {COMPANY.phone}
                </a>
              </p>
              <p>
                <a href={`mailto:${COMPANY.email}`} className="hover:text-steel transition-colors duration-300">
                  {COMPANY.email}
                </a>
              </p>
            </address>
          </div>
        </div>
      </div>

      {/* Massive brand mark */}
      <div className="border-t border-white/10 overflow-hidden">
        <div className="container-x py-10 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <h2 className="font-heading text-[15vw] md:text-[9vw] leading-[0.8] font-bold uppercase tracking-tighter text-white/[0.06] select-none">
            Ascendance
          </h2>
          <p className="text-xs text-textmuted tracking-widest uppercase whitespace-nowrap">
            © {new Date().getFullYear()} — Innovation · Precision · Dedication
          </p>
        </div>
      </div>
    </footer>
  );
};
